import Axios from 'axios';

import { getCookie } from 'common/utils/cookies';

// Create axios instance lazily to ensure APP_CONFIG is loaded
let platformAPI = null;

const createPlatformAPI = () => {
  if (!platformAPI) {
    platformAPI = Axios.create({
      baseURL: `${window.APP_CONFIG.env.API_HOST}`,
      timeout: 30000,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET,POST,OPTIONS,DELETE,PUT',
      },
    });

    platformAPI.interceptors.request.use(config => {
      const updatedConfig = { ...config };
      const accessToken = getCookie('access_token');

      if (accessToken) {
        updatedConfig.headers.Authorization = `Bearer ${accessToken}`;
      }

      return updatedConfig;
    });
  }

  return platformAPI;
};

// Export a proxy that creates the API instance on first access
export default new Proxy(
  {},
  {
    get(target, prop) {
      const api = createPlatformAPI();
      return api[prop];
    },
  },
);
